/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2025 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import english1x from "components/LandingPage/StudioHero/images/studio-hero-english.webp";
import english2x from "components/LandingPage/StudioHero/images/studio-hero-english@2x.webp";
import german1x from "components/LandingPage/StudioHero/images/studio-hero-german.webp";
import german2x from "components/LandingPage/StudioHero/images/studio-hero-german@2x.webp";
import french1x from "components/LandingPage/StudioHero/images/studio-hero-french.webp";
import french2x from "components/LandingPage/StudioHero/images/studio-hero-french@2x.webp";
import spanish1x from "components/LandingPage/StudioHero/images/studio-hero-spanish.webp";
import spanish2x from "components/LandingPage/StudioHero/images/studio-hero-spanish@2x.webp";
import portuguese1x from "components/LandingPage/StudioHero/images/studio-hero-portuguese.webp";
import portuguese2x from "components/LandingPage/StudioHero/images/studio-hero-portuguese@2x.webp";
import italian1x from "components/LandingPage/StudioHero/images/studio-hero-italian.webp";
import italian2x from "components/LandingPage/StudioHero/images/studio-hero-italian@2x.webp";

export const LandingPageStudioHeroImages: Record<string, { srcSet: string }> = {
  en: {
    srcSet: `${english1x} 1x, ${english2x} 2x`,
  },
  de: {
    srcSet: `${german1x} 1x, ${german2x} 2x`,
  },
  fr: {
    srcSet: `${french1x} 1x, ${french2x} 2x`,
  },
  es: {
    srcSet: `${spanish1x} 1x, ${spanish2x} 2x`,
  },
  pt: {
    srcSet: `${portuguese1x} 1x, ${portuguese2x} 2x`,
  },
  it: {
    srcSet: `${italian1x} 1x, ${italian2x} 2x`,
  },
};
